import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    auth: {
        _id: null,
        id: null,
        role: null,
        email: null,
        first_name: null,
        last_name: null,
        profile_picture: null,
        two_factor_enabled: false,

    },
    currentLocation:{ latitude: null, longitude: null }
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthInfo: (state, action) => {
            state.auth = action.payload;
        },
        clearAuthInfo: (state) => {
            state.auth = {
                id: null,
                role: null,
                email: null,
                first_name: null,
                last_name: null,
                profile_picture: null,
                two_factor_enabled: false,
            };
        },
         // Set the current location
         setCurrentLocation: (state, action) => {
            state.currentLocation = action.payload;
        },
        // Clear the current location
        clearCurrentLocation: (state) => {
            state.currentLocation = { latitude: null, longitude: null };
        },
    },
});

export const { setAuthInfo, clearAuthInfo,setCurrentLocation, clearCurrentLocation } = authSlice.actions;

export default authSlice.reducer;
